function listMissingPropertiesFrom(obj, _a) {
    var requiredProperties = _a.requiredProperties;
    return requiredProperties.reduce(function (acc, cur) {
        if (cur in obj) {
            return acc;
        }
        acc.push(cur);
        return acc;
    }, []);
}
export default listMissingPropertiesFrom;
//# sourceMappingURL=listMissingProperties.js.map